export const topicsData = [
  { id: 1, name: '娱乐圈大瓜', heat: '982W', slug: 'yule', trend: '🔥' },
  { id: 2, name: '网红黑料', heat: '876W', slug: 'wanghong', trend: '📈' },
  { id: 3, name: '明星恋情', heat: '765W', slug: 'lianqing', trend: '🔥' },
  { id: 4, name: '综艺翻车', heat: '698W', slug: 'zongyi', trend: '💥' },
  { id: 5, name: '直播事故', heat: '621W', slug: 'zhibo', trend: '📈' },
  { id: 6, name: '社会热点', heat: '587W', slug: 'shehui', trend: '🔥' },
  { id: 7, name: '体育圈八卦', heat: '512W', slug: 'tiyu', trend: '⚡' },
  { id: 8, name: '科技圈爆料', heat: '456W', slug: 'keji', trend: '📈' },
  { id: 9, name: '财经大佬', heat: '398W', slug: 'caijing', trend: '💼' },
  { id: 10, name: '文化争议', heat: '345W', slug: 'wenhua', trend: '🎯' },
];

export const indexData = [
  { id: 1, title: '本周热榜', desc: '七天之内最火爆的吃瓜内容，热度实时更新，绝不错过任何爆点', count: '128篇', icon: 'ri-fire-line' },
  { id: 2, title: '本月精选', desc: '编辑团队精心筛选的本月必看黑料合集，篇篇劲爆', count: '36篇', icon: 'ri-star-line' },
  { id: 3, title: '明星专区', desc: '一线明星最新动态、恋情曝光、综艺表现一手掌握', count: '256篇', icon: 'ri-vip-crown-line' },
  { id: 4, title: '网红观察', desc: '头部网红翻车现场、直播事故、私下黑料深度追踪', count: '189篇', icon: 'ri-eye-line' },
  { id: 5, title: '综艺追踪', desc: '热门综艺节目幕后故事、嘉宾争议、剪辑翻车全程记录', count: '97篇', icon: 'ri-tv-line' },
  { id: 6, title: '社会热点', desc: '全民关注的争议事件、舆论风波与反转真相汇总', count: '203篇', icon: 'ri-global-line' },
  { id: 7, title: '国际吃瓜', desc: '放眼海外娱乐圈与社交媒体上的劲爆话题与争议事件', count: '74篇', icon: 'ri-earth-line' },
  { id: 8, title: '经典回顾', desc: '那些年轰动全网的名场面合集，经典永不过时', count: '52篇', icon: 'ri-history-line' },
];

export const contactData = {
  title: '投稿爆料',
  description: '你有独家黑料？发现不为人知的真相？51吃瓜每日大赛欢迎每一位正义的爆料人。你的每一次投稿，都可能成为全网热议的焦点。我们承诺严格保护爆料人隐私，绝不泄露任何个人信息。',
  email: 'tips@51chigua.com',
  wechat: 'chigua51official',
  tips: ['保护爆料人隐私', '核实后第一时间发布', '重大爆料有奖励'],
};

export const cardsData = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店同框画面曝光',
    category: '明星恋情',
    time: '3小时前',
    heat: '892W',
    summary: '据知情人士透露，两人已秘密交往超过半年，此前多次被拍到同进同出但均未正面回应。此次深夜酒店同框画面清晰可见，引发粉丝群体激烈讨论。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20night%20photography%20style%2C%20luxury%20hotel%20entrance%20at%20night%20with%20warm%20golden%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20soft%20bokeh%20background%2C%20cinematic%20mood%2C%20deep%20shadows%20and%20warm%20highlights%2C%20no%20people%20visible%2C%20abstract%20narrative%20style&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '知名带货主播直播间翻车，产品虚假宣传被当场揭穿',
    category: '直播事故',
    time: '5小时前',
    heat: '756W',
    summary: '该主播在直播中宣称某护肤品具有神奇功效，却被专业观众当场用成分表打脸。直播间弹幕瞬间爆炸，品牌方紧急公关但为时已晚。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20studio%20lighting%20with%20red%20and%20warm%20tones%2C%20modern%20live%20streaming%20setup%20with%20ring%20light%2C%20product%20display%20table%2C%20tense%20atmosphere%2C%20editorial%20photography%20style%2C%20bold%20contrast%2C%20warm%20dramatic%20shadows%2C%20no%20people&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '综艺节目录制现场冲突升级，两位嘉宾当面对峙火药味十足',
    category: '综艺翻车',
    time: '8小时前',
    heat: '634W',
    summary: '节目组原本设计和平交流环节，不料两位嘉宾因旧怨当场爆发激烈争吵，导演组紧急叫停录制。现场工作人员爆料称气氛一度非常紧张。',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20dramatic%20lighting%2C%20empty%20stage%20with%20spotlights%20in%20warm%20amber%20and%20red%20tones%2C%20tense%20abandoned%20atmosphere%2C%20cinematic%20composition%2C%20high%20contrast%2C%20editorial%20style%2C%20professional%20broadcast%20environment&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '某知名企业高管内部聊天记录遭泄露，内容震惊业内',
    category: '科技圈爆料',
    time: '12小时前',
    heat: '598W',
    summary: '泄露的聊天记录显示该高管在内部群中发表大量不当言论，涉及竞争对手商业机密。公司股价应声下跌，公关部门连夜发布声明。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20at%20night%2C%20glass%20building%20with%20warm%20interior%20light%2C%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast%2C%20urban%20night%20scene%2C%20warm%20golden%20tones&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '体育明星私生活曝光，与圈外女友已秘密领证',
    category: '体育圈八卦',
    time: '1天前',
    heat: '523W',
    summary: '据知情人士透露，该运动员早在半年前就已与圈外女友领证结婚，一直低调未公开。女方为普通白领，两人经朋友介绍认识。',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20golden%20hour%20sunset%20scene%2C%20sports%20stadium%20background%20silhouette%2C%20warm%20amber%20lighting%2C%20emotional%20atmosphere%2C%20editorial%20photography%2C%20soft%20focus%2C%20cinematic%20mood%2C%20no%20people%20visible%2C%20abstract%20narrative&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '网红餐厅后厨卫生状况触目惊心，监管部门已介入调查',
    category: '社会热点',
    time: '2天前',
    heat: '487W',
    summary: '一段暗访视频曝光了某网红连锁餐厅后厨的真实状况，食材随地堆放、老鼠出没等画面令人震惊。目前该品牌多家门店已被责令停业整顿。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20kitchen%20interior%20with%20warm%20harsh%20lighting%2C%20industrial%20restaurant%20back%20area%2C%20gritty%20realistic%20atmosphere%2C%20editorial%20documentary%20style%2C%20high%20contrast%2C%20warm%20amber%20tones%2C%20investigative%20journalism%20aesthetic&width=800&height=500&seq=card-06&orientation=landscape',
  },
];

export const updatesData = [
  { id: 1, time: '15:42', date: '07-30', title: '某选秀节目选手被曝学历造假，节目组紧急声明表示正在核实', tag: '最新' },
  { id: 2, time: '14:18', date: '07-30', title: '知名博主发文暗讽同行数据造假，双方评论区互撕升级', tag: '热' },
  { id: 3, time: '12:05', date: '07-30', title: '某电商平台高管离职内幕曝光，与董事会存在严重分歧', tag: '爆' },
  { id: 4, time: '09:33', date: '07-30', title: '热门网剧编剧被指抄袭，原著作者发文维权引网友力挺', tag: '热' },
  { id: 5, time: '22:47', date: '07-29', title: '某知名品牌代言人翻车，广告宣传夸大功效被消费者集体投诉', tag: '' },
  { id: 6, time: '18:20', date: '07-29', title: '音乐节现场设备故障导致演出中断，观众要求退票引发混乱', tag: '' },
  { id: 7, time: '15:55', date: '07-29', title: '某直播平台头部主播涉嫌偷税漏税被约谈，账号已被冻结', tag: '爆' },
];

export const commentsData = [
  {
    id: 1,
    name: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20style%2C%20warm%20coral%20gradient%20circle%2C%20clean%20flat%20design%2C%20modern%20geometric%20pattern%2C%20simple%20bold%20colors%2C%20no%20text&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '2小时前',
    content: '这个瓜我先吃为敬！信息量太大了，感觉这周又有得追了。小编速度真快，刚发生就出稿了👍',
    likes: 3286,
  },
  {
    id: 2,
    name: '理性吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20style%2C%20warm%20amber%20gradient%20circle%2C%20clean%20flat%20design%2C%20modern%20geometric%20pattern%2C%20simple%20bold%20colors%2C%20no%20text&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '3小时前',
    content: '建议大家理性看待，等待官方回应。不过证据确实挺锤的，想洗都难……',
    likes: 2103,
  },
  {
    id: 3,
    name: '娱乐圈观察家',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20style%2C%20deep%20red%20gradient%20circle%2C%20clean%20flat%20design%2C%20modern%20geometric%20pattern%2C%20simple%20bold%20colors%2C%20no%20text&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '4小时前',
    content: '早就听说内娱这些事了，今天终于有人爆料了。只能说贵圈真乱，期待后续发展。',
    likes: 1856,
  },
  {
    id: 4,
    name: '今日份快乐源泉',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20style%2C%20warm%20orange%20gradient%20circle%2C%20clean%20flat%20design%2C%20modern%20geometric%20pattern%2C%20simple%20bold%20colors%2C%20no%20text&width=80&height=80&seq=avatar-04&orientation=squarish',
    time: '5小时前',
    content: '每天打开51吃瓜已经成为习惯了，比追电视剧还精彩，哈哈哈！继续更新不要停！',
    likes: 1522,
  },
  {
    id: 5,
    name: '福尔摩斯·瓜',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20style%2C%20coral%20pink%20gradient%20circle%2C%20clean%20flat%20design%2C%20modern%20geometric%20pattern%2C%20simple%20bold%20colors%2C%20no%20text&width=80&height=80&seq=avatar-05&orientation=squarish',
    time: '6小时前',
    content: '我仔细分析了一下时间线，这个爆料的时间点选得很微妙啊，刚好在对方新剧开播前一天……',
    likes: 987,
  },
];

export const faqData = [
  {
    id: 1,
    q: '51吃瓜每日大赛的内容来源是什么？',
    a: '我们的内容来源于网络公开信息、网友投稿以及编辑团队的深度挖掘与整理。所有爆料均基于公开可查的信息渠道，致力于为广大吃瓜群众提供第一手、真实的黑料资讯。',
  },
  {
    id: 2,
    q: '如何向51吃瓜每日大赛投稿爆料？',
    a: '您可以通过页面底部的联系方式发送邮件至我们的官方邮箱，或添加官方微信进行投稿。我们承诺严格保护每一位爆料人的个人隐私，核实后的内容将优先发布。',
  },
  {
    id: 3,
    q: '51吃瓜每日大赛每天更新几次？',
    a: '我们的编辑团队全天候关注热点事件，通常每天更新10-20条最新爆料内容。重大突发事件发生时，我们会第一时间跟进报道，确保时效性。',
  },
  {
    id: 4,
    q: '如何区分真实爆料与虚假信息？',
    a: '我们建立了严格的内容审核机制，每条爆料发布前都需经过多方交叉验证。对于暂时无法核实的信息，我们会明确标注"待核实"标签，并持续追踪后续进展。',
  },
  {
    id: 5,
    q: '51吃瓜每日大赛与其他吃瓜平台有何不同？',
    a: '我们不仅是信息的搬运工，更注重内容的深度与广度。除了即时爆料，我们还提供事件时间线梳理、相关人物关系图谱、深度分析文章等增值内容，让你吃瓜吃得更明白、更过瘾。',
  },
];

export const rankingData = [
  { id: 1, rank: 1, title: '某顶流男星深夜密会神秘女子事件', heat: '892W', change: 'up' },
  { id: 2, rank: 2, title: '带货主播直播间翻车虚假宣传', heat: '756W', change: 'up' },
  { id: 3, rank: 3, title: '综艺节目录制现场嘉宾对峙冲突', heat: '634W', change: 'new' },
  { id: 4, rank: 4, title: '知名企业高管聊天记录泄露风波', heat: '598W', change: 'down' },
  { id: 5, rank: 5, title: '网红餐厅后厨卫生触目惊心', heat: '487W', change: 'up' },
];

export const aboutData = {
  title: '关于51吃瓜每日大赛',
  paragraphs: [
    '51吃瓜每日大赛成立于2024年，是国内领先的黑料吃瓜资讯聚合平台。我们以"让吃瓜变得专业"为核心理念，致力于为全网吃瓜群众提供最新、最全、最真实的爆料内容。',
    '我们的编辑团队由资深娱乐记者、互联网观察者和数据分析师组成，全天候监控社交媒体、新闻平台、论坛社区等多个信息渠道，确保不遗漏任何有价值的黑料线索。',
    '作为爆料第一站，51吃瓜每日大赛已累计发布超过5000条独家爆料，覆盖娱乐圈、网红圈、体育圈、科技圈、财经圈等多个领域，日均访问量突破百万。',
    '我们坚持真实、客观、深度的内容原则，所有爆料均经过严格核实流程。对于每一位投稿的爆料人，我们承诺严格保密个人信息，绝不辜负信任。',
  ],
  stats: [
    { label: '累计爆料', value: '5,280+' },
    { label: '日均访问', value: '100W+' },
    { label: '覆盖领域', value: '10+' },
    { label: '忠实用户', value: '350W+' },
  ],
};

export const carouselData = [
  {
    id: 1,
    title: '内娱顶流塌房全记录',
    subtitle: '2024-2025年度回顾',
    desc: '从一线明星到顶流偶像，那些曾经光鲜亮丽的形象如何一步步崩塌。本文梳理了近两年内娱圈最轰动的塌房事件。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20spotlight%20on%20empty%20red%20carpet%2C%20luxury%20award%20ceremony%20venue%2C%20warm%20golden%20and%20crimson%20lighting%2C%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20grand%20but%20empty%20theater%2C%20high%20contrast%2C%20dramatic%20mood&width=800&height=480&seq=carousel-01&orientation=landscape',
    tag: '年度专题',
  },
  {
    id: 2,
    title: '直播带货黑幕大起底',
    subtitle: '揭秘行业潜规则',
    desc: '从虚假宣传到数据造假，从产品质量到售后服务，我们深入调查了直播带货行业不为人知的灰色地带。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20studio%20with%20professional%20lighting%20equipment%2C%20ring%20lights%20and%20cameras%2C%20product%20display%20shelves%2C%20warm%20dramatic%20lighting%2C%20editorial%20photography%2C%20behind%20the%20scenes%20aesthetic%2C%20high%20contrast%2C%20investigative%20mood&width=800&height=480&seq=carousel-02&orientation=landscape',
    tag: '深度调查',
  },
  {
    id: 3,
    title: '网红圈人设崩塌实录',
    subtitle: '从爆火到凉凉的完整时间线',
    desc: '我们整理了近一年来最轰动的网红人设崩塌事件，分析背后的共性规律与教训。',
    image: 'https://readdy.ai/api/search-image?query=Broken%20mirror%20reflecting%20colorful%20social%20media%20icons%2C%20dramatic%20lighting%2C%20warm%20coral%20and%20gold%20tones%2C%20abstract%20conceptual%20photography%2C%20editorial%20style%2C%20fragmented%20composition%2C%20high%20contrast%2C%20modern%20digital%20art%20aesthetic&width=800&height=480&seq=carousel-03&orientation=landscape',
    tag: '人设崩塌',
  },
  {
    id: 4,
    title: '综艺节目翻车名场面',
    subtitle: '那些让导演崩溃的瞬间',
    desc: '精选近年来综艺节目中最经典的事故与翻车画面，每一个都堪称教科书级的尴尬现场。',
    image: 'https://readdy.ai/api/search-image?query=Television%20production%20set%20with%20dramatic%20red%20emergency%20lighting%2C%20empty%20studio%20chairs%2C%20professional%20camera%20equipment%2C%20tense%20atmosphere%2C%20cinematic%20photography%2C%20warm%20dramatic%20tones%2C%20editorial%20style%2C%20behind%20the%20scenes&width=800&height=480&seq=carousel-04&orientation=landscape',
    tag: '综艺经典',
  },
  {
    id: 5,
    title: '2025下半年吃瓜日历',
    subtitle: '提前锁定重点吃瓜节点',
    desc: '根据行业规律与历史数据，我们预测了下半年最值得关注的吃瓜时间节点与潜在热门事件类型。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20calendar%20with%20dramatic%20warm%20lighting%2C%20luxury%20desk%20setup%2C%20golden%20accents%2C%20editorial%20photography%2C%20sophisticated%20atmosphere%2C%20warm%20amber%20and%20coral%20tones%2C%20high%20contrast%2C%20modern%20magazine%20style&width=800&height=480&seq=carousel-05&orientation=landscape',
    tag: '前瞻预测',
  },
];

export const appData = {
  title: '随时随地，吃瓜不耽误',
  description: '下载51吃瓜APP，第一时间获取最新爆料推送。支持iOS与Android双平台，离线阅读、夜间模式、个性化推荐等丰富功能等你体验。',
  features: ['实时推送提醒', '离线缓存阅读', '夜间护眼模式', '个性化内容推荐'],
  iosQr: 'https://readdy.ai/api/search-image?query=Minimalist%20QR%20code%20style%20abstract%20pattern%2C%20warm%20coral%20gradient%20background%2C%20modern%20clean%20design%2C%20geometric%20square%20pattern%2C%20simple%20elegant%20digital%20art&width=200&height=200&seq=app-qr-01&orientation=squarish',
  androidQr: 'https://readdy.ai/api/search-image?query=Minimalist%20QR%20code%20style%20abstract%20pattern%2C%20warm%20amber%20gradient%20background%2C%20modern%20clean%20design%2C%20geometric%20square%20pattern%2C%20simple%20elegant%20digital%20art&width=200&height=200&seq=app-qr-02&orientation=squarish',
};

export const mediaData = [
  {
    id: 1,
    title: '本周吃瓜大盘点：最劲爆的五条爆料一次看完',
    duration: '08:32',
    views: '126W',
    image: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20with%20bold%20warm%20red%20and%20gold%20graphic%20design%2C%20news%20headline%20aesthetic%2C%20modern%20media%20player%20interface%2C%20dramatic%20lighting%2C%20editorial%20design%2C%20high%20contrast%2C%20sensational%20news%20style&width=640&height=360&seq=media-01&orientation=landscape',
    tag: '每周精选',
  },
  {
    id: 2,
    title: '独家解读：某顶流塌房事件背后的利益链条',
    duration: '12:45',
    views: '98W',
    image: 'https://readdy.ai/api/search-image?query=Investigative%20documentary%20style%20thumbnail%2C%20dramatic%20warm%20lighting%2C%20mysterious%20atmosphere%2C%20dark%20background%20with%20golden%20highlights%2C%20editorial%20design%2C%20professional%20media%20aesthetic%2C%20high%20contrast%2C%20news%20expose%20style&width=640&height=360&seq=media-02&orientation=landscape',
    tag: '深度分析',
  },
  {
    id: 3,
    title: '吃瓜现场：综艺录制翻车全流程还原',
    duration: '06:18',
    views: '87W',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20behind%20the%20scenes%20with%20dramatic%20warm%20lighting%2C%20professional%20camera%20rigs%2C%20empty%20set%20with%20tension%20atmosphere%2C%20editorial%20photography%2C%20cinematic%20mood%2C%20warm%20amber%20and%20coral%20tones&width=640&height=360&seq=media-03&orientation=landscape',
    tag: '现场还原',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速爆料',
    desc: '7×24小时全天候监控，重大事件发生后15分钟内即可发布第一手爆料内容，绝不让你错过任何精彩瞬间。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '严格核实',
    desc: '每条爆料发布前必经三方交叉验证，标注可信度等级。宁可慢一步，也绝不传播未经证实的虚假信息。',
  },
  {
    id: 3,
    icon: 'ri-user-heart-line',
    title: '隐私保护',
    desc: '采用业界领先的匿名保护技术，严格保障每一位爆料人的个人信息安全。你的信任，是我们最珍视的财富。',
  },
];

export const footerPartners = [
  '合作伙伴',
];